<template>
    <div>
        <span>秒杀价格(USD)</span>
        <el-popover
            placement="bottom"
            width="340"
            trigger="click"
            v-model="spikeBatchVisible">
            <div class="f">
                <div style="margin-right:8px;">
                优惠规则:
                </div>
                <div>
                <el-radio-group v-model="radioSpike" @change="radioChange">
                    <el-radio :label="1">固定折扣</el-radio>
                    <el-radio :label="2">固定减价</el-radio>
                </el-radio-group>
                <div style="margin-bottom:8px" v-if="radioSpike === 1">
                    <el-input
                        v-model="spikePriceBatchValue1"
                        style="width:180px;margin-right:4px"
                        @input="value=> numCheck(value, {target: this, key: 'spikePriceBatchValue1'})"
                        @blur="e => floatCheck(e, {target: this, key: 'spikePriceBatchValue1'})"></el-input>
                    <span>%  off</span>
                </div>
                <div style="margin-bottom: 8px" v-else>
                    <div>
                        <el-input
                        v-model="spikePriceBatchValue2"
                        style="width:180px;margin-right:4px"
                        @input="value=> numCheck(value, {target: this, key: 'spikePriceBatchValue2'})"
                        @blur="e => floatCheck(e, {target: this, key: 'spikePriceBatchValue2'})"></el-input>
                    </div>
                    <div style="color:red;margin-top: 6px">最大不能超过{{maxSpikePrice}}</div>
                </div>
                <div class="f-b" style="margin-bottom:8px;width: 200px">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
                </div>
            </div>
            <i class="el-icon-s-unfold pointer" slot="reference" style="color:#add049" v-if="mode !== 'edit'"></i>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        tab: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'add'
        },
        tableList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            spikeBatchVisible: false,
            radioSpike: 1,
            spikePriceBatchValue1: undefined,
            spikePriceBatchValue2: undefined
        }
    },
    computed: {
        maxSpikePrice() {
            let num = undefined
            this.tableList.forEach(e=>{
                if(!num) num = e.price
                if(e.price < num) num = e.price
            })
            return num
        }
    },
    methods: {
        radioChange(value) {},
        submit() {
            if(this.radioSpike === 2 && this.spikePriceBatchValue2 > this.maxSpikePrice) {
                return this.$message.error('减价金额必须小于最小实际售价')
            }
            const params = {
                type: this.radioSpike,
                value: this.radioSpike === 1 ?this.spikePriceBatchValue1: this.spikePriceBatchValue2,
                tab: this.tab === '已在活动中' ? 'tableInDiscount': 'tableDataStorageAll'
            }
            this.$emit('change', params)
            this.spikeBatchVisible = false
        },
        cancel() {
            this.spikeBatchVisible = false
        },
        // 可输小数点
        numCheck(value, info) {
            const { target, key } = info
            let finalValue = value.replace(/[^\d.]/g, '')
            if(finalValue.startsWith('0')) finalValue = undefined
            if(+finalValue === 0) finalValue = undefined
            if (!finalValue) finalValue = undefined
            target[key] = finalValue
        },
        floatCheck(e, info) {
            const { target, key } = info
            let value = parseFloat(e.target.value)
            if (Number.isNaN(value)) {
                value = null
            }
            target[key] = parseFloat(value.toFixed(2))
            if(key === 'spikePriceBatchValue1' && target[key] >= 100) {
                target[key] = 99
            }
        },
    },
}
</script>